/**
 * Creates a ripple effect on a button or interactive element
 * @param {Event} e - The mouse event that triggered the ripple
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleRipple = (e: { currentTarget: any; clientX: number; clientY: number; }) => {
  const button = e.currentTarget;
  const ripple = document.createElement('span');
  const rect = button.getBoundingClientRect();
  const size = Math.max(button.clientWidth, button.clientHeight);
  const x = e.clientX - rect.left - size / 2;
  const y = e.clientY - rect.top - size / 2;

  ripple.className = 'ripple';
  ripple.style.width = `${size}px`;
  ripple.style.height = `${size}px`;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;

  button.appendChild(ripple);

  ripple.addEventListener('animationend', () => {
    ripple.remove();
  });
};

export default handleRipple;
